import { IRoute } from "../../../common/helpers/routesMapper";
import { seo } from "../../../common/helpers/seo";

import Login from "./lazy";

export default {
    component: Login,

    renderSeo: (store: any, allMessage: any, lang: string) => {
        return seo({ title: `Musicators - ${allMessage.slogen}`, allMessage, lang });
    },
} satisfies IRoute;
